import { IsBoolean, IsNumber, IsOptional, Max, Min } from 'class-validator';

export class UpdateSubAgentDealDto {
  @IsOptional()
  @IsNumber({}, { message: 'Please enter a valid rake share percentage' })
  @Min(5, { message: 'Rake share percentage must be at least 5%' })
  @Max(45, { message: 'Rake share percentage cannot exceed 45%' })
  rakeSharePercentage?: number;

  /**
   * Controls whether the sub-agent can create their own sub-agents.
   */
  @IsOptional()
  @IsBoolean({ message: 'canCreateSubAgents must be a boolean value' })
  canCreateSubAgents?: boolean;
}
